/* eslint-disable no-unused-vars */
import { useCallback, useEffect, useMemo } from 'react';
import ModalWrapper from './ModalWrapper';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { applicationActions } from 'store/application';
import { isPublisherRole } from 'store/selectors';
import { GooglePlayLogo, SamsungStoreLogo, MiStoreLogo, WebsiteLogo } from 'assets/icons';
import * as S from './AddNewAppModal.styled';
import GooglePage from './pages/googlePage/GooglePage';
import WebsitePage from './pages/websitePage/WebsitePage';
import SamsungAndXiaomiPages from './pages/samsungAndXiaomiPage/SamsungAndXiaomiPages';
import { RadioBox } from 'components';

const pages = {
  google: GooglePage,
  samsung: SamsungAndXiaomiPages,
  xiaomi: SamsungAndXiaomiPages,
  website: WebsitePage,
};

export const AddNewAppModal = ({
  open,
  handleClose,
  chooseAction = () => {},
  isWebsite,
  isWebsiteHidden = false,
  isAppHidden = false,
}) => {
  const dispatch = useDispatch();
  const currentTab = useSelector((state) => state.application.currentTab);
  const isPublisher = useSelector(isPublisherRole);
  const isWebsiteTabHidden = isWebsiteHidden || isPublisher;

  const handleTabChange = useCallback((newValue) => {
    dispatch(applicationActions.selectTab(newValue));
  }, []);

  const availableTabs = useMemo(() => {
    const tabs = [];
    if (!isAppHidden) tabs.push('google');
    if (!isWebsiteTabHidden) tabs.push('website');
    return tabs;
  }, [isAppHidden, isWebsiteTabHidden]);

  useEffect(() => {
    if (!availableTabs.length) return;
    if (!availableTabs.includes(currentTab)) {
      dispatch(applicationActions.selectTab(availableTabs[0]));
    }
  }, [availableTabs, currentTab, dispatch]);

  const ComponentToShow = pages[availableTabs.includes(currentTab) ? currentTab : availableTabs[0]];

  return (
    <ModalWrapper title='Add new application' open={open} handleClose={handleClose}>
      <S.NewAppContainer>
        <S.Content>
          <S.Label>Store:</S.Label>
          <div>
            <S.StoreTabs>
              {!isAppHidden && (
                <RadioBox.CustomWithIcon
                  label='Google Play'
                  icon={GooglePlayLogo}
                  width={184}
                  height={44}
                  value={'google'}
                  pressed={currentTab === 'google'}
                  onChange={handleTabChange}
                />
              )}
              {!isWebsiteTabHidden && (
                <RadioBox.CustomWithIcon
                  label='Website'
                  icon={WebsiteLogo}
                  width={184}
                  height={44}
                  value={'website'}
                  pressed={currentTab === 'website'}
                  onChange={handleTabChange}
                />
              )}
              {/* <RadioBox.CustomWithIcon
                width={184}
                height={44}
                label='Samsung Store'
                variant='center'
                icon={SamsungStoreLogo}
                value={'samsung'}
                pressed={currentTab === 'samsung'}
                onChange={handleTabChange}
                disabled={false}
              /> */}
              {/* <RadioBox.CustomWithIcon
                width={184}
                height={44}
                label='Mi Store'
                variant='right'
                icon={MiStoreLogo}
                value={'xiaomi'}
                pressed={currentTab === 'xiaomi'}
                onChange={handleTabChange}
                disabled={true}
              /> */}
            </S.StoreTabs>
          </div>
        </S.Content>
        <ComponentToShow handleClose={handleClose} chooseAction={chooseAction} page={currentTab} />
      </S.NewAppContainer>
    </ModalWrapper>
  );
};

AddNewAppModal.propTypes = {
  handleClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};
